import { useState } from 'react';
import Icon from './Icons';
import Revelar from './Revelar';
import './Acordeao.css';

/**
 * Lista de perguntas e respostas. Usada na home e nas páginas de área.
 * @param {{pergunta: string, resposta: string}[]} itens
 * @param {string} idBase prefixo dos ids, para não colidir se houver dois na mesma página
 */
export default function Acordeao({ itens, idBase = 'faq', animar = true }) {
  const [aberta, setAberta] = useState(0);

  const alternar = (indice) => setAberta((atual) => (atual === indice ? null : indice));

  return (
    <ul className="acordeao">
      {itens.map((item, indice) => {
        const expandida = aberta === indice;
        const idPergunta = `${idBase}-pergunta-${indice}`;
        const idResposta = `${idBase}-resposta-${indice}`;

        return (
          <Revelar
            as="li"
            key={idPergunta}
            atraso={animar ? indice * 60 : 0}
            className={`duvida ${expandida ? 'duvida--aberta' : ''}`}
          >
            <h3>
              <button
                type="button"
                className="duvida__botao"
                onClick={() => alternar(indice)}
                aria-expanded={expandida}
                aria-controls={idResposta}
                id={idPergunta}
              >
                <span>{item.pergunta}</span>
                <Icon name="chevron" size={20} className="duvida__seta" />
              </button>
            </h3>

            <div
              className="duvida__resposta"
              id={idResposta}
              role="region"
              aria-labelledby={idPergunta}
              hidden={!expandida}
            >
              <p>{item.resposta}</p>
            </div>
          </Revelar>
        );
      })}
    </ul>
  );
}
